<template>
  <div>
    <b-card>
      <b-card-title class="mb-1">Документы пользователя</b-card-title>
      <b-card-text class="text-muted">
        Руководства собираются при каждом выпуске и обновляются вместе со сборкой.
        Документ, помеченный как актуальный, соответствует версии
        <strong v-if="appVersion">{{ appVersion }}</strong><span v-else>приложения</span>,
        которая сейчас опубликована.
      </b-card-text>
    </b-card>

    <b-alert v-if="error" variant="warning" show class="mb-2">
      <div class="alert-body">{{ error }}</div>
    </b-alert>

    <b-row>
      <b-col v-for="document in documents" :key="document.kind" md="4" sm="12">
        <b-card class="h-100">
          <div class="d-flex justify-content-between align-items-start mb-1">
            <feather-icon icon="FileTextIcon" size="22" class="text-primary" />
            <b-badge v-if="document.is_current" variant="light-success">актуальный</b-badge>
            <b-badge
              v-else-if="document.version"
              variant="light-warning"
              v-b-tooltip.hover="'Документ собран для версии ' + document.version + ', а опубликована ' + appVersion"
            >
              отстал от сборки
            </b-badge>
            <b-badge v-else variant="light-secondary">не опубликован</b-badge>
          </div>

          <h5 class="mb-25">{{ document.title }}</h5>
          <p class="text-muted small mb-1">{{ document.audience }}</p>

          <template v-if="document.version">
            <p class="mb-1">
              <strong>Версия {{ document.version }}</strong>
              <span class="text-muted"> · {{ sizeKb(document.size) }} КБ · {{ date(document.published) }}</span>
            </p>
            <b-button variant="primary" size="sm" :href="document.url" target="_blank" class="mb-1">
              <feather-icon icon="DownloadIcon" size="14" class="mr-50" />
              Скачать
            </b-button>

            <div v-if="document.history.length">
              <b-button
                variant="flat-secondary"
                size="sm"
                @click="opened = opened === document.kind ? null : document.kind"
              >
                Прежние версии ({{ document.history.length }})
              </b-button>
              <b-list-group v-if="opened === document.kind" flush class="mt-50">
                <b-list-group-item
                  v-for="old in document.history"
                  :key="old.file"
                  :href="old.url"
                  target="_blank"
                  class="d-flex justify-content-between align-items-center px-0 py-50"
                >
                  <span>Версия {{ old.version }}</span>
                  <span class="text-muted small">{{ date(old.published) }}</span>
                </b-list-group-item>
              </b-list-group>
            </div>
          </template>

          <p v-else class="text-muted small mb-0">
            Документ этого вида ещё не выложен. Выпуск сборки без него не проходит проверку,
            поэтому он появится с ближайшей версией.
          </p>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BCardTitle, BCardText, BRow, BCol, BButton, BBadge, BAlert,
  BListGroup, BListGroupItem, VBTooltip,
} from 'bootstrap-vue'

export default {
  name: 'DocumentationList',
  components: {
    BCard, BCardTitle, BCardText, BRow, BCol, BButton, BBadge, BAlert,
    BListGroup, BListGroupItem,
  },
  directives: { 'b-tooltip': VBTooltip },
  data() {
    return { documents: [], appVersion: null, opened: null, error: null }
  },
  async created() {
    try {
      const response = await this.$http.get('documentation/')
      this.documents = response.data.documents
      this.appVersion = response.data.app_version
    } catch (e) {
      // Раздача может быть ещё не наполнена — говорим об этом прямо, пустая
      // страница выглядела бы так, будто документов не предусмотрено
      this.error = 'Список документов недоступен: раздача не отвечает или документы ещё не выложены.'
    }
  },
  methods: {
    sizeKb(size) {
      return size ? Math.round(size / 1024) : 0
    },
    date(value) {
      if (!value) return ''
      return new Date(value).toLocaleDateString('ru-RU', {
        day: '2-digit', month: 'long', year: 'numeric',
      })
    },
  },
}
</script>
